import React from 'react';
import styles from './styles.module.css';
import { SupportInfo } from '../support-info';
import { AuthMenu } from '../auth-menu';

export const Footer = () => {
  return (
    <header className={styles.headerContainer}>
      <div className={styles.headerContent}>
        <SupportInfo />
      </div>
      <AuthMenu />
    </header>
  );
};
